export default {
    'terms.title': 'Terms of Use',
} as Record<string, string>;
